export default {
	data() {
		return {
			shouldRegisterChanges: false,
			isValuesChanged: false,
		};
	},
	methods: {
		clearValuesChanged() {
			this.isValuesChanged = false;
			this.$emit("sheet-values-changed", null);
		},
	},
	watch: {
		values: {
			handler() {
				if (this.shouldRegisterChanges) {
					this.isValuesChanged = true;
					this.$emit("sheet-values-changed", this.values);
				}
			},
			deep: true,
		},
	},
	mounted() {
		//super hacky.
		// discover what is causing the values to get changed on mount
		// and then refactor this to be more reliable
		setTimeout(() => {
			this.shouldRegisterChanges = true;
		}, 100);
	},

	destroyed() {
		this.clearValuesChanged();
	},
};
